import {
  BONUSX_SUBSCRIPTION_TIERS,
  GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP,
} from "../../legacy/services/user-subscription/enums/bonusx-subscription-tiers.enum";

export function resolveUserTierAtEvent(currentUserTier: string): BONUSX_SUBSCRIPTION_TIERS {
  return GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP[currentUserTier] ?? BONUSX_SUBSCRIPTION_TIERS.FREE;
}
